// extracted by mini-css-extract-plugin
export default {"container":"ListPlaceholder_container__fhM0I"};